import MyWorkAppModal from './MyWorkAppModal'

var MyWorkApp = new MyWorkAppModal()
export default MyWorkApp
